module.exports = __webpack_public_path__ + "static/media/spaceCrxillion01.e32ac8a7.png";